const templateUrl = require('./shipping-dropdown.html');

const ogShippingDropdown = {
  templateUrl: templateUrl,
  bindings: {
    model: '=ngModel',
    addresses: '<ogAddresses'
  }
};

module.exports = ogShippingDropdown;
